import * as React from 'react';
import styled from 'styled-components';
import 'src/ReactTableStyles.css';
import 'react-table/react-table.css';
import { SolutionFile } from 'src/models/SolutionFile';
import { Flex, FlexDirection } from '../Flex/Flex';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { H3 } from '../Elements/Elements';
import { FileTypes, ResponsiveSize, FlexPosition, Color, ImageFileTypes } from '../Globals/Globals';
import { PdfPreview } from './PdfPreview';
import { Loader } from '../Loader/Loader';

const ModalContainer = styled.div`
  display: ${(props: IModalWrapperProps) => (props.show ? 'flex' : 'none')};
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.4);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  align-items: center;
  justify-content: center;
`;

const ModalWrapper = styled(Flex)`
  background: white;
  min-width: 50%;
  min-height: 50%;
  max-width: 90%;
  max-height: 90%;
  border-radius: 1em;
  padding: 1em;

  transition: width 2s;

  @media (min-width: ${ResponsiveSize.laptopL}) {
    max-width: 60%;
  }
`;

const ModalTitle = styled(Flex)`
  height: 2em;
  flex-grow: 0;
  align-items: center;
  justify-content: space-between;
`;

const ModalBody = styled(Flex)`
  flex-grow: 1;
  align-items: center;
  justify-content: center;
  padding: 1em;
`;

const ModalFooter = styled(Flex)`
  height: 2em;
  flex-grow: 0;
  flex-shrink: 0;
`;

const CloseButton = styled(FontAwesomeIcon)`
  padding: 1em;
  cursor: pointer;
`;

const TitleText = styled(H3)`
  padding: 1em;
  overflow-x: auto;
`;

// Wrapper for images (JPG, PNG)
const ImageWrapper = styled.img`
  max-height: 70vh;
  max-width: 100%;
`;

const DownloadLinkWrapper = styled.a`
  cursor: pointer;
  padding-right: 1em;

  &:hover {
    color: ${Color.blue};
  }
`;

interface IFilePreviewProps {
  file: SolutionFile;
  show: boolean;
  loading: boolean;
  fileUrl: string;
  onClose(): void;
  download(file: SolutionFile): void;
}

interface IModalWrapperProps {
  show: boolean;
}

export class FilePreview extends React.Component<IFilePreviewProps> {
  constructor(props: IFilePreviewProps) {
    super(props);

    this.state = {
      show: true
    };
  }

  public renderPreview = () => {
    switch (this.props.file.fileType) {
      case FileTypes.JPG:
      case FileTypes.PNG:
        return <ImageWrapper src={this.props.fileUrl} />;
      default:
        return <PdfPreview src={this.props.fileUrl} />;
    }
  };

  // Renders the download button for the preview.
  public renderDownloadButton() {
    // If file type is pdf or image, we can directly use fileUrl.
    // If type is something else, for example pptx, the fileUrl is pointing at the preview file, not the original.
    // In this case we need to download the original file using download -function from props.
    if (
      ImageFileTypes.indexOf(this.props.file.fileType) !== -1 ||
      this.props.file.fileType === FileTypes.PDF
    ) {
      return (
        <DownloadLinkWrapper
          href={this.props.fileUrl}
          download={`${this.props.file.id}.${this.props.file.fileType.toLowerCase()}`}
        >
          Download
          <FontAwesomeIcon style={{ marginLeft: 5 }} icon="download" />
        </DownloadLinkWrapper>
      );
    } else {
      return (
        <DownloadLinkWrapper
          onClick={event => {
            event.preventDefault();
            this.props.download(this.props.file);
          }}
        >
          Download <FontAwesomeIcon style={{ marginLeft: 5 }} icon="download" />
        </DownloadLinkWrapper>
      );
    }
  }

  public render() {
    return (
      <ModalContainer show={this.props.show}>
        <ModalWrapper direction={FlexDirection.column}>
          <ModalTitle onClick={this.props.onClose}>
            <TitleText>{!this.props.loading && this.props.file.title + '(Preview)'} </TitleText>
            <CloseButton icon="times" />
          </ModalTitle>
          <ModalBody>{this.props.loading ? <Loader /> : this.renderPreview()}</ModalBody>
          <ModalFooter alignHorizontal={FlexPosition.right}>
            {!this.props.loading && this.renderDownloadButton()}
          </ModalFooter>
        </ModalWrapper>
      </ModalContainer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FilePreview/FilePreview.tsx